import { useQuery } from '@tanstack/react-query'

import { usePetriApi } from '@/frontend/hooks/api/use-petri-api'

/** Returns the current staff member's review. A missing Petri log rejects with PetriLogNotFoundError. */
export function useGetPatientSummaryReview({ externalId }: { externalId: string | null }) {
  const petri = usePetriApi()

  return useQuery({
    queryKey: ['patient-summary-review', externalId],
    queryFn: () => petri.getReview(externalId!),
    enabled: Boolean(externalId),
  })
}
